import { render, staticRenderFns } from "./VDesignTaskExecutors.vue?vue&type=template&id=1d37c201&"
import script from "./VDesignTaskExecutors.vue?vue&type=script&lang=ts&"
export * from "./VDesignTaskExecutors.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignTaskExecutors.vue?vue&type=style&index=0&id=1d37c201&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports